__webpack_require__.p = "https://veridart-customer-app-prod.s3-us-west-2.amazonaws.com/";